module.exports = __webpack_public_path__ + "static/media/sortArrow.889773c3.svg";